module.exports = __webpack_public_path__ + "img/lisata.18e2b727.png";